import { Component } from 'vue';
import type { RawLocation } from 'vue-router';

export interface MenuItemOptions {
  icon?: Component;
  height?: Number;
  width?: Number;
  iconClasses?: string;
  labelText: string;
  href?: string;
  to?: RawLocation;
  target?: '_blank' | '_self';
  closeOnClick?: boolean;
  click: () => void | Promise<void>;
  labelClasses?: string;
}

/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
export enum IconType {
  KEBAB = 'kebab',
  HAMBURGER = 'hamburger',
}
